import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtErr } from "../lib/api";

export const LOGO_URL = "/images/logo.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("innpact_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-black/15 px-4 py-3.5 text-sm font-light focus:outline-none focus:border-black transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <form
        onSubmit={handleSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border border-black/5 p-10 md:p-12"
      >
        <img src={LOGO_URL} alt="INN.PACT — Clínica de Imagem" className="h-24 mx-auto mb-8 object-contain" />
        <p className="label-editorial text-black/50 text-center mb-10">Backoffice</p>
        {error && (
          <p data-testid="login-error" className="text-sm text-red-600 mb-6 font-light">
            {error}
          </p>
        )}
        <div className="space-y-5">
          <input
            data-testid="login-email-input"
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className={inputCls}
          />
          <input
            data-testid="login-password-input"
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className={inputCls}
          />
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full label-editorial bg-black text-white py-4 hover:bg-black/80 transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "A entrar…" : "Entrar"}
          </button>
        </div>
      </form>
    </div>
  );
}
